module.exports = "/_next/static/images/myetherwallet-f2b4d52a61543f4e311fc687d4089ee7.png";